<template>
  <v-card
    :style="`width: ${cardWidth}px; height: ${cardHeight}px;`"
    class="rounded-lg team-card-shadow"
    color="white"
    flat
  >
    <div class="team-card">
      <v-img
        :max-height="size"
        :max-width="size"
        src="../../assets/team-icon.svg"
      />
      <div class="team-content">
        <v-card-text class="card-title" style="padding: 0">
          <div class="team-name text-left">
            {{ team.name }}
          </div>
        </v-card-text>
        <div class="team-participants">
          <v-img
            :max-height="17"
            :max-width="17"
            src="../../assets/generic_user.svg"
          />
          <div class="members-text">
            {{ numberOfTeamMembers }}
          </div>
          <v-img
            :max-height="17"
            :max-width="13"
            src="../../assets/lightbulb.svg"
          />
          <div class="members-text">
            {{ numberOfTickets }}
          </div>
          <BasePill
            v-if="isVirtualTeam"
            :label="$t('page.teams.virtualTeam')"
          />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BasePill from "./BasePill.vue";

@Component({
  name: "BaseTeamCard",
  components: {
    BasePill,
  },
})
export default class BaseTeamCard extends Vue {
  @Prop({ default: 46 }) size!: number;

  @Prop({ default: "grey lighten-2" }) colorClass!: string;

  @Prop({ default: "Team name" }) teamName!: string;

  @Prop({ default: "300" }) cardWidth!: string;

  @Prop({ default: "85" }) cardHeight!: string;

  @Prop({ default: "fas fa-user-friends" }) faIcon!: string;

  @Prop({ default: "fa fa-user" }) personIcon!: string;

  @Prop({ default: "fa fa-cog" }) ticketIcon!: string;

  @Prop({ default: 0 }) numberOfTeamMembers!: number;

  @Prop({ default: 0 }) numberOfTickets!: number;
}
</script>

<style lang="scss" scoped>
.team-card {
  box-shadow: 0 0 20px 0 rgba(210, 210, 210, 0.6);
  display: flex;
  padding: 20px;
}

.team-content {
  padding-left: 17px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.team-participants {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.members-text {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
  color: #a6a6a6;
}

.team-card-icon {
  font-size: 13px;
}

.team-name {
  font-size: 15px;
  font-weight: 500;
  color: $primary_text_color;
}
</style>
